import axiosInstance from './axiosInstance';
import { PATH_NAME } from '../configs/pathName';
import { ICreateOrderRequest, IOrder, IOrderAPIResponse } from '../models/IWallet';

export const getOrderById = async (order_id: string): Promise<IOrder> => {
  const response = await axiosInstance.get(PATH_NAME.API_GET_ORDER_ID(order_id));
  return response.data.result.items;
};

export const createOrder = async (orderData: ICreateOrderRequest): Promise<IOrder> => {
  try {
    const response = await axiosInstance.post<IOrderAPIResponse>(PATH_NAME.API_CREATE_ORDER, orderData);
    return response.data.result.items;
  } catch (error) {
    console.error('Error creating order:', error);
    throw error;
  }
};